import cn from 'translations/cn.json'
import en from 'translations/en.json'
import de from 'translations/de.json'
import es from 'translations/es.json'
import it from 'translations/it.json'
import pl from 'translations/pl.json'
import jp from 'translations/jp.json'
import { store } from '../redux/store'

const translations = {
  cn,
  en,
  de,
  es,
  it,
  pl,
  jp,
}

const getNestedValue = (obj, key) => {
  if (Array.isArray(key)) {
    return key.reduce((curr, k) => curr?.[k], obj)
  }

  if (typeof key === 'string') {
    return key.split('.').reduce((curr, k) => curr?.[k], obj)
  }

  return obj?.[key]
}

const getTranslatedLabelForFormField = (key) => {
  if (!key || typeof key !== 'string') {
    console.warn('Invalid key provided for translation', key)

    return key || ''
  }

  // Get locale from redux store
  const state = store.getState()
  const { locale } = state.auth.locale

  const localeTranslations = translations[locale] || translations.en

  // Use string split to create array of translation keys to traverse and fetch translations accordingly
  const keys = key.split('.')
  let result = localeTranslations

  keys.forEach((k) => {
    result = getNestedValue(result, k)
  })

  return result || keys[keys.length - 1] // Return the last key if translation not found
}

export default getTranslatedLabelForFormField
